import { createContext } from 'react';

import type { SearchType } from '#/modules/search/types/SearchType';

export const LayoutHeaderDefaultSearchTypeContext =
  createContext<SearchType>('JOB');
